import { LayoutDashboard, Wallet, Users, CalendarCheck, IndianRupee, Receipt, FileText, BarChart3, Building2 } from "lucide-react";

const SIDEBAR = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
  { id: "finance", label: "Finance", icon: Wallet },
  { id: "hr", label: "Employees", icon: Users },
  { id: "attendance", label: "Attendance", icon: CalendarCheck },
  { id: "payroll", label: "Payroll", icon: IndianRupee },
  { id: "expenses", label: "Expenses", icon: Receipt },
  { id: "invoices", label: "Invoices", icon: FileText },
  { id: "reports", label: "Reports", icon: BarChart3 },
];

const VIEWS = {
  dashboard: {
    title: "Business Overview",
    stats: [["Total Income", "₹4,82,300"], ["Total Expenses", "₹2,15,750"], ["Pending Invoices", "12"], ["Active Employees", "38"]],
    bars: [45, 62, 55, 78, 70, 88, 92],
    rows: [["Center A — Payroll processed", "₹1,84,000", "Done"], ["Invoice #INV-1042 sent", "₹24,500", "Pending"], ["Expense approved — Travel", "₹8,320", "Approved"]],
  },
  finance: {
    title: "Finance & Accounting",
    stats: [["This Month Income", "₹4,82,300"], ["This Month Expense", "₹2,15,750"], ["Net Position", "₹2,66,550"], ["Centers", "4"]],
    bars: [60, 48, 72, 66, 80, 74, 90],
    rows: [["Center B — Operating expense", "₹42,100", "Recorded"], ["Program income — Batch 12", "₹96,000", "Recorded"], ["Vendor payment — Supplies", "₹18,450", "Approved"]],
  },
  hr: {
    title: "Employee Management",
    stats: [["Total Employees", "38"], ["Trainers", "22"], ["Support Staff", "16"], ["New This Month", "3"]],
    bars: [30, 45, 40, 55, 60, 58, 70],
    rows: [["Anjali Sharma — Trainer, Center A", "Active", "Full-time"], ["Rahul Verma — Coordinator", "Active", "Full-time"], ["Priya Nair — Accounts", "Active", "Part-time"]],
  },
  attendance: {
    title: "Attendance — Today",
    stats: [["Present", "34"], ["On Leave", "3"], ["Absent", "1"], ["Centers Reporting", "4/4"]],
    bars: [88, 92, 85, 90, 94, 89, 91],
    rows: [["Center A — 12/12 present", "100%", "Synced"], ["Center B — 9/10 present", "90%", "Synced"], ["Center C — 8/9 present", "89%", "Synced"]],
  },
  payroll: {
    title: "Payroll — June 2026",
    stats: [["Payroll Amount", "₹4,12,600"], ["Employees Paid", "38"], ["Payable Days (Avg)", "26.2"], ["Status", "Processed"]],
    bars: [70, 72, 75, 73, 78, 80, 84],
    rows: [["Attendance synced from 4 centers", "38 employees", "Auto"], ["Deductions & allowances applied", "₹12,400", "Auto"], ["Payroll approved by Admin", "06 Jun", "Approved"]],
  },
  expenses: {
    title: "Expense Management",
    stats: [["This Month", "₹2,15,750"], ["Pending Approval", "6"], ["Top Category", "Operations"], ["Over Budget", "0"]],
    bars: [40, 55, 48, 62, 58, 66, 60],
    rows: [["Travel — Center C visit", "₹8,320", "Approved"], ["Training material — Batch 14", "₹15,200", "Pending"], ["Utilities — Center A", "₹6,780", "Approved"]],
  },
  invoices: {
    title: "Invoice Management",
    stats: [["Raised This Month", "18"], ["Paid", "11"], ["Pending", "5"], ["Overdue", "2"]],
    bars: [50, 65, 58, 72, 68, 76, 82],
    rows: [["INV-1042 — Skill Program Fee", "₹24,500", "Sent"], ["INV-1041 — Corporate Training", "₹68,000", "Paid"], ["INV-1038 — Workshop Services", "₹12,000", "Overdue"]],
  },
  reports: {
    title: "Reports & Analytics",
    stats: [["Reports Available", "24"], ["Center-wise P&L", "Ready"], ["Payroll Summary", "Ready"], ["Expense Analysis", "Ready"]],
    bars: [55, 60, 68, 74, 70, 82, 86],
    rows: [["Center-wise P&L — June", "4 centers", "Export"], ["Payroll register — June", "38 employees", "Export"], ["Expense by category", "8 categories", "Export"]],
  },
};

export default function ProductMockup({ active = "dashboard", compact = false, alt }) {
  const view = VIEWS[active] || VIEWS.dashboard;
  return (
    <div data-testid={`product-mockup-${active}`} role="img" aria-label={alt || "Mashara Finance business management dashboard — finance, HRMS, payroll, attendance and operations"} className="rounded-2xl border border-slate-200 bg-white shadow-2xl shadow-slate-900/10 overflow-hidden text-left">
      <div className="flex items-center gap-1.5 px-4 py-2.5 bg-slate-100 border-b border-slate-200">
        <span className="w-2.5 h-2.5 rounded-full bg-red-400" />
        <span className="w-2.5 h-2.5 rounded-full bg-amber-400" />
        <span className="w-2.5 h-2.5 rounded-full bg-emerald-400" />
        <span className="ml-3 text-[10px] text-slate-500 bg-white rounded px-2 py-0.5 border border-slate-200">finance.masharaskills.com/app</span>
      </div>
      <div className="flex" style={{ minHeight: compact ? 260 : 380 }}>
        <div className="hidden sm:flex flex-col w-36 bg-slate-900 p-2 gap-0.5">
          <div className="flex items-center gap-1.5 px-2 py-2 mb-1">
            <span className="w-5 h-5 rounded bg-emerald-600 text-white text-[10px] font-bold flex items-center justify-center">M</span>
            <span className="text-white text-[10px] font-semibold">Mashara</span>
          </div>
          {SIDEBAR.map((s) => (
            <div key={s.id} className={`flex items-center gap-1.5 px-2 py-1.5 rounded-md text-[10px] ${s.id === active ? "bg-emerald-700 text-white" : "text-slate-400"}`}>
              <s.icon className="w-3 h-3" /> {s.label}
            </div>
          ))}
          <div className="mt-auto flex items-center gap-1.5 px-2 py-1.5 text-[10px] text-slate-500">
            <Building2 className="w-3 h-3" /> 4 Centers
          </div>
        </div>
        <div className="flex-1 bg-slate-50 p-3 sm:p-4">
          <div className="flex items-center justify-between mb-3">
            <p className="text-xs sm:text-sm font-semibold text-slate-800">{view.title}</p>
            <span className="text-[9px] bg-emerald-100 text-emerald-800 rounded-full px-2 py-0.5 font-medium">Live</span>
          </div>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 mb-3">
            {view.stats.map(([label, value]) => (
              <div key={label} className="bg-white rounded-lg border border-slate-200 p-2">
                <p className="text-[8px] sm:text-[9px] text-slate-500">{label}</p>
                <p className="text-[11px] sm:text-sm font-bold text-slate-900">{value}</p>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-2">
            <div className="bg-white rounded-lg border border-slate-200 p-2.5">
              <p className="text-[9px] text-slate-500 mb-2">Weekly trend</p>
              <div className="flex items-end gap-1 h-16 sm:h-20">
                {view.bars.map((h, i) => (
                  <div key={i} className="flex-1 rounded-t bg-emerald-600/80" style={{ height: `${h}%` }} />
                ))}
              </div>
            </div>
            <div className="bg-white rounded-lg border border-slate-200 p-2.5">
              <p className="text-[9px] text-slate-500 mb-1.5">Recent activity</p>
              <div className="space-y-1.5">
                {view.rows.map(([a, b, c], i) => (
                  <div key={i} className="flex items-center justify-between text-[8px] sm:text-[9px]">
                    <span className="text-slate-600 truncate mr-2">{a}</span>
                    <span className="text-slate-800 font-medium whitespace-nowrap">{b}</span>
                    <span className={`ml-1 px-1.5 py-0.5 rounded-full font-medium whitespace-nowrap ${["Done", "Approved", "Paid", "Synced", "Auto", "Export"].includes(c) ? "bg-emerald-50 text-emerald-700" : c === "Overdue" ? "bg-red-50 text-red-600" : "bg-amber-50 text-amber-700"}`}>{c}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
